module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_97-933cbe89bbdeeccd75644483a631b1a6.png";